var React = require('react');

function IcCancel48px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z"}));
}

IcCancel48px.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = IcCancel48px;

IcCancel48px.default = IcCancel48px;
